/**
 * Created by piyushkantm on 08/07/17.
 */

export class Image {
  id: number;
  sort_order: number;
  caption: string;
  thumb_url: string;
  medium_url: string;
  original_url: string;
  created_at: string;
  updated_at: string;
  live_on_airbnb:boolean;
  live_on_homeaway:boolean;
}
